export enum Day {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
  SATURDAY = 5,
  SUNDAY = 6,
}

export const DayJPMap: { [key: number]: string } = {
  0: '月曜日',
  1: '火曜日',
  2: '水曜日',
  3: '木曜日',
  4: '金曜日',
  5: '土曜日',
  6: '日曜日',
};
